import { SET_MAP_MODE, MapModeActionTypes } from "./action";

interface MapModeState {
  isMapMode: boolean;
}

const initialState: MapModeState = {
  isMapMode: true,
};

const mapModeReducer = (
  state = initialState,
  action: MapModeActionTypes
): MapModeState => {
  switch (action.type) {
    case SET_MAP_MODE:
      return {
        ...state,
        isMapMode: action.payload,
      };
    default:
      return state;
  }
};

export default mapModeReducer; 